import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/hooks/redux";
import { useToast } from "@/components/ui/use-toast";

export const useSuspensionCheck = () => {
  const userData = useAppSelector((state) => state.auth.userData);
  const { toast } = useToast();
  const { t } = useTranslation();

  const isSuspended = useMemo(() => {
    // return true;
    if (!userData?.user?.is_suspended) return false;
    if (!userData?.user?.suspension_end_date) return false;
    return new Date(userData.user.suspension_end_date) > new Date();
  }, [userData?.user?.is_suspended, userData?.user?.suspension_end_date]);

  const suspensionEndDate = userData?.user?.suspension_end_date;

  const checkAndNotify = useCallback(() => {
    if (isSuspended && suspensionEndDate) {
      const formattedDate = new Date(suspensionEndDate).toLocaleDateString();
      toast({
        title: t("suspension.action_blocked_title"),
        description: t("suspension.action_blocked_message", { date: formattedDate }),
        variant: "destructive",
      });
      return true; // blocked
    }
    return false; // allowed
  }, [isSuspended, suspensionEndDate, toast, t]);

  return { isSuspended, suspensionEndDate, checkAndNotify };
};
